<ui-assignee [uiAssignee]="currentCheckIn.assignee" [uiNameEllipsis]="true" uiSize="md"></ui-assignee>
&nbsp;
<span class="assignee-name-suffix" *ngIf="currentCheckIn.isCurrentUser">({{ "me" | localize }})</span>
<div class="ui-collapse-panel-header-extras">
  <div class="ui-collapse-panel-header-extras-icon">
    <i *ngIf="!currentCheckIn.isEditing && currentCheckIn.mood" [class]="currentCheckIn.mood" [uiType]="currentCheckIn.mood" ui-icon></i>
  </div>
  <reflection-label-group
    class="sp-mr-16"
    *ngIf="!currentCheckIn.isActive"
    [labels]="currentCheckIn.labels | filterLabels : filter"
    [ngStyle]="{ flex: 'none' }"
    [maxVisible]="maxVisibleLabels"></reflection-label-group>
</div>
